import * as React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Button, CircularProgress, TableCell, TableRow, TextField } from "@material-ui/core";
import { Notification, useNotify } from "react-admin";
import { ENDPOINTS } from "../apiConstants";
import { getConfigGet } from "../getConfig";
import { DataTable, PageHeader, StatusChip, errorMessage, fmtDateTime, gbp, listOf, useCloStyles, walletTotal } from "./shared";

const COLUMNS = [
  { label: "User ID" },
  { label: "Available", numeric: true },
  { label: "Unswept", numeric: true },
  { label: "In e-wallet", numeric: true },
  { label: "Status" },
  { label: "Last app session" },
  { label: "Last credit" },
  { label: "Closed" },
  { label: "Updated" },
];

const Wallets = () => {
  const classes = useCloStyles();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [wallets, setWallets] = useState<any[]>([]);
  const [userId, setUserId] = useState("");

  const fetchWallets = async (forUser = userId) => {
    const trimmed = forUser.trim();
    if (trimmed && !/^\d+$/.test(trimmed)) {
      notify("User ID must be a number", "warning");
      return;
    }
    try {
      setLoading(true);
      const res: any = await axios.get(ENDPOINTS.CLO_WALLETS, getConfigGet(trimmed ? { user_id: trimmed } : {}));
      setWallets(listOf(res.data));
    } catch (err) {
      notify(errorMessage(err, "Failed to load wallets"), "warning");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWallets();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const clear = () => {
    setUserId("");
    fetchWallets("");
  };

  return (
    <div className={classes.main}>
      <PageHeader
        title="Wallets"
        subtitle="Customers' CLO cash back balances. Open one for its full history, notices and adjustments."
      />

      <div className={classes.filterContainer}>
        <TextField
          variant="outlined"
          size="small"
          label="User ID"
          className={classes.filterField}
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && fetchWallets()}
        />
        <Button className={classes.filterButton} variant="contained" color="primary" disableElevation onClick={() => fetchWallets()} disabled={loading}>
          Search
        </Button>
        <Button className={classes.filterButton} variant="outlined" onClick={clear}>Clear</Button>
      </div>

      {loading ? (
        <div className={classes.loadingContainer}><CircularProgress size={40} /></div>
      ) : (
        <DataTable
          columns={COLUMNS}
          isEmpty={wallets.length === 0}
          empty={userId ? "This customer has no CLO wallet yet." : "No wallets yet. A wallet opens with a customer's first cash back credit."}
        >
          {wallets.map((w) => (
            <TableRow key={w.id} hover className={classes.clickableRow} onClick={() => history.push(`/clo/wallets/${w.user_id}`)}>
              <TableCell>{w.user_id}</TableCell>
              <TableCell align="right"><strong>{gbp(walletTotal(w))}</strong></TableCell>
              <TableCell align="right">{gbp(w.available_minor)}</TableCell>
              <TableCell align="right">{gbp(w.swept_unspent_minor)}</TableCell>
              <TableCell><StatusChip status={w.status} /></TableCell>
              <TableCell>{fmtDateTime(w.last_app_session_at)}</TableCell>
              <TableCell>{fmtDateTime(w.last_credit_at)}</TableCell>
              <TableCell>{fmtDateTime(w.closed_at)}</TableCell>
              <TableCell>{fmtDateTime(w.updatedAt)}</TableCell>
            </TableRow>
          ))}
        </DataTable>
      )}

      <Notification />
    </div>
  );
};

export default Wallets;
